const store = new Map();
export default store;
